export default "__VITE_ASSET__C8jDPNs6__"